(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["im-blog-feed"] && !Shopify.designMode) return;
  try {
    
  //show all blog posts in blog page
  $('p.view-all').click(function () {
    sectionName = $(this).parents('.blog-feed__container').attr('class').split(' ').pop();
    $('.blog-feed__container.' + sectionName + ' .blog-feed__content .blog-feed__item').css('display', 'flex');
    $(this).hide();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["im-blog-filters"] && !Shopify.designMode) return;
  try {
    

    //show all blog categories in blog page
    $('p.view-all--filter').click(function() {
        $('.filters .blog-filters__item').css('display','flex');
        $(this).hide();
    });

    //filters blog categories
    $('.blog-filters__item').click(function() {
    categoryName = $(this).children('p.title').text();
    categoryName = categoryName.toLowerCase().replace(/&/g,"").replace(/\s/g, '').replaceAll(',','');
    // alert(categoryName);
    
    $('.'+categoryName).show();
    $('.blog-feed__container:not(".'+categoryName+'")').hide();
    $('.blog-feed__container.videos').show();
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["im-collapsible-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var coll = document.querySelectorAll("button[id$='index']");
    for (var i = 0; i < coll.length; i++) {
      coll[i].addEventListener('click', function () {
        this.classList.toggle('active');
        var content = this.nextElementSibling;
        if (content.style.display === 'block') {
          content.style.display = 'none';
        } else {
          content.style.display = 'block';
          $('button:not(#' + this.id + ')').removeClass('active');
          $('button:not(#' + this.id + ') + .collapsible-content').css('display', 'none');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["im-featured-products"] && !Shopify.designMode) return;
  try {
    
  // $(function () {
  //     var x = 0;
  //     var z = 1;
  //     var w = 1;
  //     var started = true;
  //     var sim;

  //     function doSimulate() {
  //      sim = setInterval(function () {
  //          x -= 0.1;
  //          if (x <= -70.0) {
  //              z++;
  //              x = 100;
  //         	}
  //         	$('#movimg').css('left', x + "%");
  //     	}, 10);
  //     }
  //     doSimulate();
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["im-product-grid"] && !Shopify.designMode) return;
  try {
    
  // $(function () {
  //     var x = 0;
  //     var z = 1;
  //     var w = 1;
  //     var started = true;
  //     var sim;

  //     function doSimulate() {
  //      sim = setInterval(function () {
  //          x -= 0.1;
  //          if (x <= -70.0) {
  //              z++;
  //              x = 100;
  //         	}
  //         	$('#movimg').css('left', x + "%");
  //     	}, 10);
  //     }
  //     doSimulate();
  // });

  } catch(e) { console.error(e); }
})();
})();
